import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { Field, reduxForm, change } from 'redux-form';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ValidatedInput from "../../../components/ValidatedInput";
import ValidatedSelect from "../../../components/ValidatedSelect";
import { getStates, getAllCities } from "../../../utils/helper";

const AccountOwnerAddressInfo = ({ nextStep, prevStep, handleSubmit, active, processing, secondary, dispatch, investAccount }) => {

    const [states] = useState(getStates());
    const [cities] = useState(getAllCities());
    const [liveAtThisHomeLessThanYear, setLiveAtThisHomeLessThanYear] = useState(false);

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                dispatch(change('AccountOwnerAddressInfoForm', 'current_home_address', investAccount.secondary_account_owner_current_home_address || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_home_address_alternate', investAccount.secondary_account_owner_current_home_address_alternate || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_city', investAccount.secondary_account_owner_current_city || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_state', investAccount.secondary_account_owner_current_state || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_zip_code', investAccount.secondary_account_owner_current_zip_code || null));
                setLiveAtThisHomeLessThanYear(investAccount.is_secondary_account_owner_living_for_more_than_one_year || false);
            } else {
                dispatch(change('AccountOwnerAddressInfoForm', 'current_home_address', investAccount.primary_account_owner_current_home_address || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_home_address_alternate', investAccount.primary_account_owner_current_home_address_alternate || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_city', investAccount.primary_account_owner_current_city || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_state', investAccount.primary_account_owner_current_state || null));
                dispatch(change('AccountOwnerAddressInfoForm', 'current_zip_code', investAccount.primary_account_owner_current_zip_code || null));
                setLiveAtThisHomeLessThanYear(investAccount.is_primary_account_owner_living_for_more_than_one_year || false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const toggleLiveAtThisHomeLessThanYear = () => {
        setLiveAtThisHomeLessThanYear(!liveAtThisHomeLessThanYear);
    };

    const handleNext = (formData) => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_current_home_address = formData.current_home_address;
            payload.secondary_account_owner_current_home_address_alternate = formData.current_home_address_alternate;
            payload.secondary_account_owner_current_city = formData.current_city;
            payload.secondary_account_owner_current_state = formData.current_state;
            payload.secondary_account_owner_current_zip_code = formData.current_zip_code;
            payload.is_secondary_account_owner_living_for_more_than_one_year = liveAtThisHomeLessThanYear;
        } else {
            payload.primary_account_owner_current_home_address = formData.current_home_address;
            payload.primary_account_owner_current_home_address_alternate = formData.current_home_address_alternate;
            payload.primary_account_owner_current_city = formData.current_city;
            payload.primary_account_owner_current_state = formData.current_state;
            payload.primary_account_owner_current_zip_code = formData.current_zip_code;
            payload.is_primary_account_owner_living_for_more_than_one_year = liveAtThisHomeLessThanYear;
        }

        nextStep(
            payload,
            liveAtThisHomeLessThanYear ? 0 : 1
        );
    };

    const handleBack = () => {
        prevStep();
    }

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>What's the current Home Address of the {secondary ? 'secondary' : 'primary'} owner?</span>
                </div>
                <div className="account-info-container">
                    <FormGroup row>
                        <Label sm={5}>Address Line 1</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                name="current_home_address"
                                placeholder="Address Line 1" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={5}>Address Line 2 (optional)</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                name="current_home_address_alternate"
                                placeholder="Address Line 2" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={5}>City</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                options={cities}
                                isSearchable={true}
                                isClearable={true}
                                name="current_city"
                                placeholder="Select City" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={5}>State</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedSelect}
                                options={states}
                                isSearchable={true}
                                isClearable={true}
                                name="current_state"
                                placeholder="Select State" />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={5}>Zip Code</Label>
                        <Col sm={7}>
                            <Field
                                component={ValidatedInput}
                                type="text"
                                name="current_zip_code"
                                placeholder="Zip Code" />
                        </Col>
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" onChange={toggleLiveAtThisHomeLessThanYear} checked={liveAtThisHomeLessThanYear} />
                            Lived at this home for less than a year
                        </Label>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

const validate = (values) => {
    const errors = {};
    if (!values.current_home_address) {
        errors.current_home_address = 'Field is required';
    }
    if (!values.current_city) {
        errors.current_city = 'Field is required';
    }
    if (!values.current_state) {
        errors.current_state = 'Field is required';
    }
    if (!values.current_zip_code) {
        errors.current_zip_code = 'Field is required';
    }
    if (values.current_zip_code &&
        !/^\d{5}(?:[-\s]\d{4})?$/.test(values.current_zip_code)) {
        errors.current_zip_code = 'Invalid zip code'
    }
    return errors;
};

export default reduxForm({
    form: 'AccountOwnerAddressInfoForm',
    validate,
})(AccountOwnerAddressInfo);
